import { EMBED_ATTRIBUTE } from '../constants/dndAreaDomConstants';
export const buildGlobalGroupSelector = path => {
  return `[data-global-widget-path="${path}"]:not([${EMBED_ATTRIBUTE}])`;
};
export const buildGlobalPartialSelector = path => {
  return `[data-global-resource-path="${path}"]:not([${EMBED_ATTRIBUTE}])`;
};